import axios from 'axios';

export function subscribe(data) {
  return axios.post(`${window.apiBase}/public/subscribe`, data).then(response => {
    return response.data;
  });
}
